var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 19,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.029166667 0 0 0.029166667 0.16666692 -0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L640 0L640 480L0 480L0 0z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L640 0L640 144L0 144L0 0z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 336L640 336L640 480L0 480L0 336z",
    stroke: "none",
    fill: "#006600",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3 0 0 3 320 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-28.6 47.5L-26.800001 48.5L19.9 -32.5C 22.6 -33.1 24.099998 -35.7 25.599998 -38.3C 26.599998 -40.1 30.599998 -47 32.3 -56C 27.555756 -51.784096 23.535652 -46.818096 20.4 -41.3C 18.9 -38.7 17.4 -36.1 18.1 -33.399998L18.1 -33.399998L-28.6 47.5z",
    stroke: "#000000",
    strokeWidth: 1,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.6 47.5L-26.800001 48.5L19.9 -32.5C 22.6 -33.1 24.099998 -35.7 25.599998 -38.3C 26.599998 -40.1 30.599998 -47 32.3 -56C 27.555756 -51.784096 23.535652 -46.818096 20.4 -41.3C 18.9 -38.7 17.4 -36.1 18.1 -33.399998L18.1 -33.399998L-28.6 47.5z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3 0 0 3 320 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-28.6 47.5L-26.800001 48.5L19.9 -32.5C 22.6 -33.1 24.099998 -35.7 25.599998 -38.3C 26.599998 -40.1 30.599998 -47 32.3 -56C 27.555756 -51.784096 23.535652 -46.818096 20.4 -41.3C 18.9 -38.7 17.4 -36.1 18.1 -33.399998L18.1 -33.399998L-28.6 47.5z",
    stroke: "#000000",
    strokeWidth: 1,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.6 47.5L-26.800001 48.5L19.9 -32.5C 22.6 -33.1 24.099998 -35.7 25.599998 -38.3C 26.599998 -40.1 30.599998 -47 32.3 -56C 27.555756 -51.784096 23.535652 -46.818096 20.4 -41.3C 18.9 -38.7 17.4 -36.1 18.1 -33.399998L18.1 -33.399998L-28.6 47.5z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M640.5 168L377 168C 368 144 338 96 320 96C 302 96 272 144 263 168L263 168L-0.2 168L-0.2 312L263 312C 272 336 302 384 320 384C 338 384 368 336 377 312L377 312L640.5 312L640.5 168z",
    stroke: "none",
    fill: "#BB0000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 -0 0 1 640 0)",
    d: "M377 312C 386 288 392 264 392 240C 392 216 386 192 377 168C 368 192 362 216 362 240C 362 264 368 288 377 312",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 -0 0 1 640 0)",
    d: "M377 312C 386 288 392 264 392 240C 392 216 386 192 377 168C 368 192 362 216 362 240C 362 264 368 288 377 312",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3 0 0 3 320 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4 0C -4 -3.3137088 -2.209139 -6 0 -6C 2.209139 -6 4 -3.3137088 4 0C 4 3.3137088 2.209139 6 0 6C -2.209139 6 -4 3.3137088 -4 0",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 -0 -0 -1 0 0)",
    d: "M1 5.8C 1 5.8 5 13.8 5 26.8C 5 39.8 1 47.8 1 47.8L1 47.8L1 5.8z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 -0 -0 -1 0 0)",
    d: "M1 5.8C 1 5.8 5 13.8 5 26.8C 5 39.8 1 47.8 1 47.8L1 47.8L1 5.8z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 -0 -0 -1 0 0)",
    d: "M1 5.8C 1 5.8 5 13.8 5 26.8C 5 39.8 1 47.8 1 47.8L1 47.8L1 5.8z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 -0 -0 -1 0 0)",
    d: "M1 5.8C 1 5.8 5 13.8 5 26.8C 5 39.8 1 47.8 1 47.8L1 47.8L1 5.8z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.32fb664076286e5bc1dd08edf368e589.svg";
export { ForwardRef as ReactComponent };